export default "__VITE_ASSET__vBZ_G_e3__"